import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Animated, Easing, StyleSheet, View } from 'react-native';
import GenericTouchable, { TOUCHABLE_STATE } from './GenericTouchable';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/**
 * TouchableOpacity bases on timing animation which has been used in RN's core
 */

var TouchableOpacity =
/*#__PURE__*/
function (_Component) {
  _inherits(TouchableOpacity, _Component);

  function TouchableOpacity() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TouchableOpacity);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TouchableOpacity)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getChildStyleOpacityWithDefault", function () {
      var childStyle = StyleSheet.flatten(_this.props.style) || {};
      return childStyle.opacity == null ? 1 : childStyle.opacity;
    });

    _defineProperty(_assertThisInitialized(_this), "opacity", new Animated.Value(_this.getChildStyleOpacityWithDefault()));

    _defineProperty(_assertThisInitialized(_this), "setOpacityTo", function (value, duration) {
      Animated.timing(_this.opacity, {
        toValue: value,
        duration: duration,
        easing: Easing.inOut(Easing.quad),
        useNativeDriver: true
      }).start();
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (from, to) {
      if (to === TOUCHABLE_STATE.BEGAN) {
        _this.setOpacityTo(_this.props.activeOpacity, 0);
      } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        _this.setOpacityTo(_this.getChildStyleOpacityWithDefault(), 150);
      }
    });

    return _this;
  }

  _createClass(TouchableOpacity, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          rest = _objectWithoutProperties(_this$props, ["style"]);

      return React.createElement(GenericTouchable, _extends({}, rest, {
        style: [style, {
          opacity: this.opacity
        }],
        onStateChange: this.onStateChange
      }), this.props.children ? this.props.children : React.createElement(View, null));
    }
  }]);

  return TouchableOpacity;
}(Component);

_defineProperty(TouchableOpacity, "defaultProps", _objectSpread({}, GenericTouchable.defaultProps, {
  activeOpacity: 0.2
}));

_defineProperty(TouchableOpacity, "propTypes", _objectSpread({}, GenericTouchable.publicPropTypes, {
  style: PropTypes.any,
  activeOpacity: PropTypes.number
}));

export { TouchableOpacity as default };